<template>
  <ats
    v-bind="$props"
    service="mistertemp"
    :credential="{ url: '', token: '', agency: '' }"
    :cached="true"
    @input="onInput">
    <template v-slot:credential="{ credential }">
      <div title="url de la liste des offres (ex : https://misterjob-jobboard.staging.mistertemp.com/hellowork.xml)">
        <label for="url">url du flux</label>
        <input v-model="credential.url" id="url" name="url"/>
        <modified :enable="value.credential.url !== credential.url"/>
      </div>
      <div title="clé d'authentification d'import candidat (ex : a1b2c3d4-5e6f-7g8h-9i0j-k1l2m3n4o5p6)">
        <label for="token">token</label>
        <input v-model="credential.token" id="secret" name="token"/>
        <modified :enable="value.credential.token !== credential.token"/>
      </div>
      <div title="code agence optionel (ex : MPLY)">
        <label for="agency">agency</label>
        <input v-model="credential.agency" id="agency" name="utm"/>
        <modified :enable="value.credential.agency !== credential.agency"/>
      </div>
    </template>
  </ats>
</template>
<script>
import Ats from './sdk-v3'
import Recruiter from '/user/recruiter/recruiter.entity'
import Search from '/requirement/entity'
import Modified from '/ats/modified'

export default {
  name: 'hippolyte.services.mistertemp.config',
  components: { Ats, Modified },
  props: {
    value: Object,
    recruiter: Recruiter,
    search: Search,
    savingConf: Boolean
  },
  methods: {
    onInput (event) {
      this.$emit('input', event)
    }
  }
}
</script>
